import protobuf, { Type } from 'protobufjs';
import { Trade } from './models/extended-trades.model';
import protoStrings from './proto-strings';

/**
 * Mapping string-model
 */
type Models = Record<string, Type>;
let models: Models = {};

/**
 * Load proto files on launch
 */
const setupDecoders = () => {
  const [
    candle,
    pairSwap,
    cexPriceUpdate,
    lastTrade,
    tradesBlock,
    cexBalanceUpdate,
    cexOrderUpdate,
  ] = [
    loadModel('candles', 'binary.Candles'),
    loadModel('pairSwap', 'binary.PairSwap'),
    loadModel('cexPriceUpdate', 'binary.CexPriceUpdate'),
    loadModel('trade', 'binary.Trade'),
    loadModel('extendedTrade', 'binary.TradesBlock'),
    loadModel('cexBalanceUpdate', 'binary.Balance'),
    loadModel('cexOrderUpdate', 'binary.Order'),
  ];

  models = {
    candle,
    pairSwap,
    cexPriceUpdate,
    lastTrade,
    tradesBlock,
    cexBalanceUpdate,
    cexOrderUpdate,
  };
};

/**
 * Parse proto strings and return Type instance
 * @param string
 * @param protoName
 * @returns
 */
const loadModel = (string: string, protoName: string): Type => {
  const root = protobuf.parse(protoStrings[string], { keepCase: true }).root;

  if (!root) {
    throw new Error('something went wrong, root is undefined');
  }

  // Obtain a message type
  return root.lookupType(protoName);
};

/**
 * Convert bytes to json object
 * @param ref
 * @param buffer
 * @returns
 */
const decodeModel = (ref: string, buffer: Uint8Array): Trade | any => {
  const model = models[ref];
  const message = model.decode(buffer);
  const object = model.toObject(message, {
    longs: String,
    enums: String,
    bytes: String,
    // see ConversionOptions
  });

  return object;
};

const decodeProtoCandle = (buffer: Uint8Array) => decodeModel('candle', buffer);

const decodeProtoTrade = (buffer: Uint8Array) =>
  decodeModel('pairSwap', buffer);

const decodeProtoLastTrade = (buffer: Uint8Array) =>
  decodeModel('lastTrade', buffer);

const decodeProtoCexPriceUpdate = (buffer: Uint8Array) =>
  decodeModel('cexPriceUpdate', buffer);

const decodeProtoTradesBlock = (buffer: Uint8Array) =>
  decodeModel('tradesBlock', buffer);

const decodeCexBalanceUpdate = (buffer: Uint8Array) =>
  decodeModel('cexBalanceUpdate', buffer);

const decodeCexOrderUpdate = (buffer: Uint8Array) =>
  decodeModel('cexOrderUpdate', buffer);

export {
  setupDecoders,
  decodeProtoCandle,
  decodeProtoTrade,
  decodeProtoCexPriceUpdate,
  decodeProtoTradesBlock,
  decodeProtoLastTrade,
  decodeCexBalanceUpdate,
  decodeCexOrderUpdate,
};
